import React from "react";
import { RichText } from "prismic-reactjs";

const TextSectionWithImage = ({ slice }) => {
  const { title, description, image } = slice.primary;

  return (
    <div className={`nc-SectionHero relative`} data-nc-id="SectionHero">
      <div className="flex flex-col lg:flex-row space-y-14 lg:space-y-0 lg:space-x-10 items-center relative text-center lg:text-left">
        {slice.variation === "imageRight" ? (
          <>
            <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
              <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
                {title ? title : "Template slice, update me!"}
              </h2>
              <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                {description ? (
                  <RichText render={description} />
                ) : (
                  <p>start by editing this slice from inside Slice Machine!</p>
                )}
              </span>
            </div>
            <div className="flex-grow">
              <img
                className="w-full"
                src={image.url}
                alt={image.alt || `TopVakantiehuizen ${title}`}
              />
            </div>
          </>
        ) : (
          <>
            <div className="flex-grow">
              <img
                className="w-full"
                src={image.url}
                alt={image.alt || `TopVakantiehuizen ${title}`}
              />
            </div>
            <div className="w-screen max-w-full xl:max-w-lg space-y-5 lg:space-y-7">
              <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
                {title ? (
                  <RichText render={title} />
                ) : (
                  <h2>Template slice, update me!</h2>
                )}
              </h2>
              <span className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
                {description ? (
                  <RichText render={description} />
                ) : (
                  <p>start by editing this slice from inside Slice Machine!</p>
                )}
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default TextSectionWithImage;
